export const UPDATE_USER = 'UPDATE_USER';
export const ADD_DOC_USER = 'ADD_DOC_USER';
export const RESET_DATA = 'RESET_DATA';
export const SET_CONFIRM_INITIALS = 'SET_CONFIRM_INITIALS';
export const SET_SESSIONS = 'SET_SESSIONS';
export const SET_AVAILABLE_BENEFITS = 'SET_AVAILABLE_BENEFITS';
